import { AfterViewInit, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import _, { replace } from 'lodash';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { PresenceStatusRemoteDto } from '../../../../generated/signalR/presence-status-remote-dto';
import { PresenceStatusType } from '../../../samwebDescription/samweb/contactStatus/presenceStatusType';
import { PresenceStatusState } from '../../../store/samwin/contact-states/presence-status/presence-status.state';

@Component({
   selector: 'samweb-presence-status',
   templateUrl: './presence-status.component.html',
   styleUrls: ['./presence-status.component.scss'],
})
export class PresenceStatusComponent implements AfterViewInit, OnChanges {
   constructor(private store: Store, private translateService: TranslateService) {}

   @Input()
   public fixedWidth: boolean;

   @Input()
   public presenceId: string;

   @Input()
   public presenceTypeValue: number;

   public presenceStatus$: Observable<{ presenceState: PresenceStatusRemoteDto; presenceStatus: PresenceStatusType }>;
   public presenceStateText$: Observable<string>;
   public lastActiveField$: Observable<Date>;

   // Is needed for virtual scrolling, the data would not update correctly otherwise.
   ngOnChanges(changes: SimpleChanges): void {
      if (
         changes?.presenceId?.previousValue !== changes?.presenceId?.currentValue ||
         changes?.presenceTypeValue?.previousValue !== changes?.presenceTypeValue?.currentValue
      ) {
         this.ngAfterViewInit();
      }
   }

   ngAfterViewInit(): void {
      this.presenceStatus$ = this.store.select(PresenceStatusState.getPresenceStateSelector(this.presenceId, this.presenceTypeValue));

      this.presenceStateText$ = this.presenceStatus$.pipe(
         switchMap((presenceStatus) => {
            if (_.isNil(presenceStatus.presenceState) || _.isNil(presenceStatus.presenceStatus)) {
               return of('');
            }
            const stateText = replace(presenceStatus.presenceState.stateText, /\s/g, '-').toLowerCase();
            if (_.isEmpty(stateText)) {
               return this.translateService.stream(presenceStatus.presenceStatus.translationKey);
            }
            const stateTextKey = `samwin.contact-status.types.presence_state_text.${stateText}`;
            return this.translateService
               .stream(stateTextKey)
               .pipe(map((translationResult) => (translationResult === stateTextKey ? presenceStatus.presenceState.stateText : translationResult)));
         })
      );

      this.lastActiveField$ = this.presenceStatus$.pipe(
         switchMap((presenceStatus) => {
            if (!_.isNil(presenceStatus.presenceState)) {
               return of(presenceStatus.presenceState.lastActive);
            }
            return of(null);
         })
      );
   }
}
